import { Injectable, Type } from '@angular/core';
import { Subject } from 'rxjs';
import { DialogInstance } from './dialog-instance';
import { BaseDialog } from './dialog-base.component';
import { DialogConfig } from './dialog.interface';

@Injectable({
    providedIn: 'root'
})
export class DialogService {

    instance$: Subject<DialogInstance> = new Subject();

    constructor() {}

    open(component: Type<BaseDialog>, data: any, config: DialogConfig = {}) {
        const instance = new DialogInstance(component, data, config);
        this.instance$.next(instance);
    }

}
